import React from "react";
import { FooterLinkIcon, FooterLinkIconItem } from './Footer-style';
import '../../icon_font.css';

export default function FooterIcon() {
   return (
      <FooterLinkIcon>
         <FooterLinkIconItem className="icon-Facebook"><span className="path1"></span><span className="path2"></span></FooterLinkIconItem>
         <FooterLinkIconItem className="icon-Twitter"> </FooterLinkIconItem>
         <FooterLinkIconItem className="icon-Google"> </FooterLinkIconItem>
      </FooterLinkIcon >
   )
}